import React from 'react';
import { Typography } from '@dev/ee-components';

import { BodyWrapper } from './styles';

interface CustomPopoverElementProps {
    image: JSX.Element;
    label: string;
    value: string;
}

interface CustomPopoverBodyProps {
    element: CustomPopoverElementProps;
}

export const CustomPopoverBody = (props: CustomPopoverBodyProps): JSX.Element => {
    const { element } = props;

    return (
        <BodyWrapper>
            {element?.image}
            <Typography variant='body1'>{element.label}</Typography>
        </BodyWrapper>
    );
};